<template>
  <div class="main">
    <van-nav-bar title="审批系统" />
    <van-form @submit="onSubmit" :submit-on-enter="false">
      <van-field input-align="right" v-model="account" label="收款账号" />
      <p class="field-p">借款金额</p>
      <van-field input-align="right" v-model="money" style="font-size: 20px;" readonly label="">
        <template v-slot:left-icon>
          <img class="leftIcon" src='~assets/image/money.png' />
        </template>
      </van-field>
      <!-- 支付方式 -->
      <van-field input-align="right" readonly clickable name="picker" right-icon="arrow" :value="playType" label="支付方式" @click="showPlayType = true" />
      <van-popup v-model="showPlayType" position="bottom">
        <van-picker show-toolbar :columns="playTypeArr" @confirm="playConfirm" @cancel="showPlayType = false" />
      </van-popup>
      <!-- 贷款用途 -->
      <van-field input-align="right" readonly clickable name="picker" right-icon="arrow"  :value="useType" label="贷款用途" @click="showUseType = true" />
      <van-popup v-model="showUseType" position="bottom">
        <van-picker show-toolbar :columns="useTypeArr" @confirm="useConfirm" @cancel="showUseType = false" />
      </van-popup>
      <!-- 贷款时间 -->
      <van-field input-align="right" readonly clickable name="picker" right-icon="arrow" :value="date" label="借款期限" @click="showdeType = true" />
      <van-popup v-model="showdeType" position="bottom">
        <van-picker show-toolbar :columns="dateArr" @confirm="deConfirm" @cancel="showdeType = false" />
      </van-popup>
      <!-- 利率 -->
      <van-field v-model="lilv" label="年利率" readonly input-align="right" />
      <!-- 还款方式 -->
      <van-field input-align="right" readonly clickable name="picker" right-icon="arrow" :value="hkType" label="还款方式" @click="showhkType = true" />
      <van-popup v-model="showhkType" position="bottom">
        <van-picker show-toolbar :columns="hkTypeArr" @confirm="hkConfirm" @cancel="showhkType = false" />
      </van-popup>
      <!-- 利率调整方式 -->
      <van-field readonly v-model="lilvType" label="利率调整方式" input-align="right" />
      <!-- 提交 -->
      <van-button round block type="info" native-type="submit">提交申请</van-button>
    </van-form>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper" @click.stop>
        <van-loading color="#0094ff">申请中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: window.localStorage.getItem('code'),
      account: '',
      money: '0.00',
      showOverlay: false,
      playType: '受托支付',
      playTypeArr: ['受托支付', '自主支付'],
      showPlayType: false,
      useType: '其它消费',
      useTypeArr: ['其它消费', '装修','耐用品消费','佳能摄像机','人物件消费'],
      showUseType: false,
      show: false,
      lilv: '0%',
      showhkType: false,
      hkType: '等额本息',
      hkTypeArr: ['等额本息', '先息后本'],
      lilvType: '固定利息',
      showdeType: false,
      date: '12个月',
      dateArr: ['12个月', '24个月', '36个月'],
    }
  },
  mounted() {
    let data = JSON.parse(window.localStorage.getItem('userInfo'));
    this.account = data.bank;
    this.api.get_info({
      code: this.code
    }).then(res => {
      if(res.code == '1') {
        this.money = res.data.money;
        this.lilv = res.data.rate+'%'
      }
    })
  },
  methods: {
    // 支付方式确认
    playConfirm(val) {
      this.playType = val;
      this.showPlayType = false;
    },
    // 贷款用途确认
    useConfirm(val) {
      this.useType = val;
      this.showUseType = false;
    },
    deConfirm(val) {
      this.date = val;
      this.showdeType = false;
    },
    hkConfirm(val) {
      this.hkType = val;
      this.showhkType = false;
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
    },
    onSubmit() {
      this.showOverlay = true
      this.api.enter_detail({
        code: this.code,
        money: this.money,
        pay_type: this.playType,
        use_to: this.useType,
        end_date: this.date,
        repayment_type: this.hkType,
        rate_type: this.lilvType
      }).then(res => {
        setTimeout(() => {
          this.$router.push('/examine/fail')
        }, 1000);
      })
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.field-p {
  font-size: 16px;
  background: #fff;
  margin-bottom: 0px;
  padding: 12px 0px 5px 16px;
}

.leftIcon {
  width: 20px;
  height: 20px;
}
</style>
